import * as React from "react";

import ClassNames from "classnames";

import Styles from "./Link.module.css";

import ExternalIcon from "../_assets/icon-external.svg";

export interface Props {
  children: any;
  url: string;
  className?: string;
  external?: boolean;
  role?: string;
  underlined?: boolean;
  truncate?: boolean;
  inactive?: boolean;
}

const Link: React.FC<Props> = props => {
  const {
    children,
    className,
    url,
    external,
    role,
    underlined,
    truncate,
    inactive
  } = props;

  return (
    <a
      className={ClassNames({
        [Styles.link]: true,
        [Styles.external]: external,
        [Styles.underlined]: underlined,
        [Styles.truncate]: truncate,
        [Styles.inactive]: inactive,
        [className]: className
      })}
      href={url}
      target={external ? "_blank" : undefined}
      role={role}
      rel={external ? "noopener" : undefined}
    >
      {children}
      {external && <ExternalIcon className={Styles.externalIcon} />}
      {external && <span className="sr-only">Opens in a new window</span>}
      {truncate && <span className="hidden absolute">{children}</span>}
    </a>
  );
};

export default Link;
